module.exports = __webpack_public_path__ + "img/hc_pro_night_3.85c73fb0.jpg";